import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import EvBatterySizingCalculator from '../components/tools/EvBatterySizingCalculator';

const EvBatterySizingPage = () => {
  return (
    <div className="min-h-screen" data-testid="ev-battery-sizing-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="EV Battery Sizing Calculator"
        description="Size a pack's cell configuration, energy, current capability, and mass from range, consumption, motor power, cell data, SOC window, and end-of-life margin."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="ev-battery-sizing-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <EvBatterySizingCalculator />
          <ToolGuideCta guidePath="/tools/ev-battery-sizing/guide" toolName="EV Battery Sizing Calculator" />
        </div>
      </section>
    </div>
  );
};

export default EvBatterySizingPage;
